import { useEffect } from "react";

export const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.replace(to + window.location.search);
  }, []);

  return null;
};
